/**
 * Capacitor external-link bridge.
 *
 * Opens off-site links in the system browser via @capacitor/browser so users are
 * not stranded outside the app inside the native webview. Guarded by
 * isCapacitorEnvironment(); on web it returns false and callers keep their existing
 * window.open behavior.
 *
 * @capacitor/browser is loaded lazily (dynamic import) so it is excluded from
 * the main entry bundle and never downloaded/parsed in MobiLoud or plain web —
 * only fetched when isCapacitorEnvironment() is true.
 */

import { isCapacitorEnvironment } from "./detection";

/**
 * Open a URL in the system browser.
 * @param {string} url
 * @returns {Promise<boolean>} true if opened via Capacitor, false if unavailable
 */
export async function capacitorOpenExternal(url) {
  if (!isCapacitorEnvironment()) {
    return false;
  }
  try {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
    return true;
  } catch {
    return false;
  }
}
